import { memo, useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { userState } from '@/store/user';

export interface SecurityLayoutProps {
  children: React.ReactNode;
}

export default memo(({ children }: SecurityLayoutProps) => {
  const setUser = useSetRecoilState(userState);

  useEffect(() => {
    setUser({
      id: 1,
      name: '本地开发',
      avatar: '',
      roles: ['admin'],
      adminUser: {
        id: 'local-dev',
        userName: '本地开发',
        admin: true,
      },
    });
  }, [setUser]);

  return <>{children}</>;
});
